import { Upload as AntdUpload } from 'antd';
import 'antd/es/upload/style/index.css';
import React from 'react';
import { IUploadProps } from './interface';

const { Dragger: AntdDragger } = AntdUpload;

export const Dragger: React.FC<IUploadProps> = (props) => {
    return <AntdDragger {...props} />;
};

const Upload: React.FC<IUploadProps> = (props) => {
    return <AntdUpload {...props} />;
};

export default Upload;
